<template>
  <div class="filter-checkbox">
    <CheckboxComponent :value="value" @input="$ev => $emit('input', $ev)" :label="$attrs.options.label" />
  </div>
</template>

<script>
import { CheckboxComponent } from 'vue-elder-checkbox'

export default {
  props: {
    value: Boolean,
  },
  components: {
    CheckboxComponent,
  },
}
</script>

<style lang="scss">
.filter-checkbox {
  padding: 0.75rem;
}
</style>
